<template>  
  <div class="PopoverOptions">
    <!-- <el-scrollbar style="height:317px"> -->
      <el-form label-width="110px" style="max-height:500px;padding-right:20px" @submit.native.prevent>
        <el-form-item v-for="(item,index) in form" :key="index" :label="item.name">
          <template>
            <el-input
              clearable
              v-if="item.baseType === 1||item.baseType === 5||item.baseType === 6" 
              v-model="item.filter">
            </el-input>
            <number-range 
              style="width:100%"
              v-if="item.baseType === 3"
              :range.sync="item.filter"
              :dataType="item.nativeName"
              @cleanRange="cleanRange(item)">
            </number-range>
            <el-date-picker
              style="width:100%"
              v-if="item.dataType === 4"
              v-model="item.filter"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              align="left">
            </el-date-picker>
          </template>
          
        </el-form-item>
      </el-form>
    <!-- </el-scrollbar>   -->
  </div>
  
</template>
<script>
import NumberRange from './NumberRange'
export default {
  name: 'PopoverOptions',
  components: {
    NumberRange
  },
  props: {
    form: {}
    // showList: {
    //   type: Array,
    //   default: []
    // }
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    cleanRange(item) {
      this.$set(item, 'filter', [])
    },
    filterChange(item) {
      const arr = this.showList.filter(s => s.id === item.id)
      if (arr.length === 0) {
        if (item.filter !== '' && item.filter !== null) {
          this.showList.push(item)
        }
      } else {
        const index = this.showList.findIndex(s => s.id === item.id)
        if (item.filter === '' || item.filter === null) {
          this.showList.splice(index, 1)
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .PopoverOptions{
    max-height:300px;
    overflow:auto;
    .el-form-item__label{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;    
      color: #99a9bf;  
    }
    .el-form-item:last-child{
      margin: 0;
    }
  }
</style>

